export const getZapierTemplateIntegrationTexts = (texts, i18nKey)=>{
    const block = texts[i18nKey];
    // WHY: the registry's template keys are compile-checked against this locale block
    // (ZapierTemplateIntegration<K>), so every lookup here is guaranteed to hit.
    const templateTitles = block.templates;
    return {
        title: block.title,
        subTitle: block.subTitle,
        description: block.description,
        templateTitle: (templateKey)=>templateTitles[templateKey]()
    };
};
